import { ArrowClockwise, CheckCircle } from "@phosphor-icons/react";

const STATUS_STYLE = {
  completed: "text-emerald-600 bg-emerald-50 border-emerald-200",
  delivered: "text-blue-600 bg-blue-50 border-blue-200",
  sent: "text-amber-600 bg-amber-50 border-amber-200",
  declined: "text-red-600 bg-red-50 border-red-200",
  voided: "text-slate-500 bg-slate-50 border-slate-200",
};

export default function DocuSignEnvelopeList({ rows, refreshing, refresh }) {
  if (!rows.length) return null;
  return (
    <div className="mt-4 space-y-2" data-testid="docusign-history">
      <div className="text-[11px] font-semibold text-muted-foreground uppercase">Enveloppes</div>
      {rows.map((r) => {
        const st = (r.status || "").toLowerCase();
        return (
          <div key={r.id} className="flex items-center justify-between gap-2 border border-border px-2.5 py-1.5 text-xs">
            <div className="min-w-0">
              <div className="font-semibold">{r.kind?.toUpperCase()} · {r.signer_email}</div>
              <div className="text-muted-foreground truncate">{new Date(r.created_at).toLocaleDateString("fr-FR")} · {r.mode === "embedded" ? "intégrée" : "email"}</div>
            </div>
            <div className="flex items-center gap-1.5 shrink-0">
              <span className={`px-2 py-0.5 border text-[10px] font-semibold ${STATUS_STYLE[st] || "text-slate-500 bg-slate-50 border-slate-200"}`}>
                {st === "completed" && <CheckCircle size={11} className="inline mr-0.5" />}
                {r.status_fr || r.status}
              </span>
              <button data-testid={`docusign-refresh-${r.envelope_id}`} onClick={() => refresh(r.envelope_id)}
                disabled={refreshing === r.envelope_id} title="Rafraîchir le statut"
                className="p-1 border border-border hover:bg-accent disabled:opacity-50">
                <ArrowClockwise size={12} className={refreshing === r.envelope_id ? "animate-spin" : ""} />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
